/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Harshwardhan",
  title: "Hi all, I'm Harshwardhan Bhangale",
  subTitle: emoji(
    "Full-Stack & AI-Integrated Software Engineer skilled in React, Next.js, Node.js, TypeScript, and Python, capable of building end-to-end scalable web applications from modern frontends to robust, cloud-native backends. Experienced in LLM-powered system design across RAG pipelines, agentic workflows, and fine-tuned models, with projects spanning a protocol-aware network intrusion detection system, an agentic study assistant deployed on Kubernetes, and an AI-driven web accessibility extension. Brings industry expertise from Nokia in deploying and maintaining 4G/5G OpenStack-based Telco Clouds, complemented by hands-on DevOps experience with Docker, Kubernetes, Jenkins CI, and ArgoCD GitOps. MS in Computer Engineering, SJSU, May 2026."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1gQQXbn0hpXs0-QXRASwoJlaIV3S6wTAO/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/hbhangale3",
  linkedin: "https://www.linkedin.com/in/harshwardhan-bhangale",
  gmail: "hbhangale3@gmail.com",
  kaggle: "https://www.kaggle.com/harshwardhanbhangale",
  //gitlab: "https://gitlab.com/saadpasta",
  //facebook: "https://www.facebook.com/saad.pasta7",
  //medium: "https://medium.com/@saadpasta",
  //stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle:
    "Full-Stack & AI-Integrated Developer building scalable, data-driven applications with modern web technologies, LLMs, and Telco-grade cloud-native infrastructure",
  skills: [
    emoji(
      "⚡ Build full-stack apps with Node.js/Express and Next.js 14 Server Components & Server Actions, designing RESTful APIs with complete CRUD and role-based access control"
    ),
    emoji(
      "⚡ Design responsive, interactive UIs with React, Next.js, TypeScript, Tailwind CSS, and shadcn/ui; integrate third-party services like Cloudinary, MapTiler, and Stripe Embedded Checkout"
    ),
    emoji(
      "⚡ Implement secure auth with Passport.js, Clerk, NextAuth.js (Google OAuth), and custom JWT middleware with protected routes and owner-level access enforcement"
    ),
    emoji(
      "⚡ Data layer: MongoDB Atlas with Mongoose, PostgreSQL via Prisma ORM on Supabase, schema design, indexing, and query optimization"
    ),
    emoji(
      "⚡ AI & LLM integration: RAG pipelines with LlamaIndex and ChromaDB, agentic workflows with CrewAI, LLM fine-tuning with QLoRA/LoRA on Falcon-1B, FAISS semantic search, and API integration with Groq, OpenAI, and Gemini"
    ),
    emoji(
      "⚡ Real-time systems: Socket.io with Redis Streams adapter for multi-instance sync, Apache Kafka producer-consumer decoupling for async message persistence"
    ),
    emoji(
      "⚡ DevOps & observability: Docker, Kubernetes (GKE), Jenkins CI, ArgoCD GitOps, Prometheus metrics instrumentation, and Grafana dashboard provisioning"
    ),
    emoji(
      "⚡ Cloud-native & Telco: OpenStack (Nova, Neutron, Cinder, Glance), Kubernetes, and Ceph across multi-node 4G/5G Telco Cloud infrastructure at Nokia"
    )
  ],
  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "San Jose State University",
      logo: require("./assets/images/SpartanSpirit[2color]_web_mod.png"),
      subHeader: "Master of Science in Computer Engineering",
      desc: "Pursuing a Master's with a concentration in software engineering, computer networks, and cybersecurity. Actively applying advanced concepts to research and real-world projects.",
      descBullets: [
        "Coursework: Data Structures & Algorithms, Operating Systems, Network Security & Applications, Computer Architecture, Software-Defined Networking (SDN), Real-Time Operating Systems (RTOS)",
        "Teaching Assistant for CMPE 127 Microprocessor Design I",
        "Semi-finalist — SVCSI CyberWarrior 2025 Applied LLM Challenge for research on LLM-powered Network Intrusion Detection Systems (Python, FAISS, LoRA, RAG)",
        "Member, SJSU Hiking Club — promoting team-building and well-being through outdoor activities"
      ]
    },
    {
      schoolName: "Sardar Vallabhbhai National Institute of Technology",
      logo: require("./assets/images/SVNIT_logo2.jpg"),
      subHeader:
        "Bachelor of Technology in Electronics & Communication Engineering",
      //duration: "August 2017 - June 2021",
      desc: "Graduated in the top percentile with extensive hands-on experience in embedded systems, computer vision, and system design. Published research in deep learning and led technical and welfare initiatives across campus.",
      descBullets: [
        "Developed autonomous robots and PID motor control systems as part of ROBOCON 2019 (Drishti Club)",
        "Built real-time image processing pipelines using Jetson Xavier and IMX390 camera at John Deere R&D",
        "Published IEEE research on liver tumor segmentation using deep learning (U-Net, skip connections, feature similarity module)",
        "Worked on VLSI validation of Pulpino core using Verilog, SystemVerilog, and Xilinx FPGA",
        "Led social initiatives (Joyfest), served as Placement Coordinator (placed 130+ students), and influenced BTech curriculum reform"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer - Cloud Automation & DevOps",
      company: "Red Hat",
      companylogo: require("./assets/images/redhat_logo.png"),
      date: "Sep 2023 – July 2024",
      desc: "Worked with the Telco Solutions team to automate and scale cloud-native telecom infrastructure using OpenStack and Ansible.",
      descBullets: [
        "Contributed to the Cloud & Network Services platform team, engineering automation for large-scale distributed Telco cloud systems by developing Ansible playbooks for control-plane health checks and onboarding workflows, reducing manual operational effort by 30% and accelerating deployment timelines through cross-functional collaboration.",
        "Drove the transition from manual VM-based VNF deployments on private on-prem OpenStack clouds to a cloud-native,containerized delivery model, packaging services as Docker containers and deploying them on Kubernetes, improving deployment consistency and eliminating application-manager–driven manual releases.",
        "Designed and validated automated CI/CD and GitOps workflows aligned with key phases of the SDLC, using Jenkins, ArgoCD, Docker, and Kubernetes to automate build, test, and deployment of containerized 4G/5G network applications, extending releases from private infrastructure to public cloud (GCP) for early-stage validation and reducing deployment time by 40%."
      ]
    },
    {
      role: "Software Engineer - Cloud Infrastructure & 5G Automation",
      company: "Nokia Solutions & Networks",
      companylogo: require("./assets/images/nokia-refreshed-logo-1_1_mod.png"),
      date: "July 2021 – Aug 2023",
      desc: "Led telco-grade OpenStack cloud deployments and automation across multi-site 5G infrastructure projects for Telco customers across Asia-Pacific & Japan region.",
      descBullets: [
        "Directed end-to-end deployment of distributed Telco Cloud platforms using an OpenStack-on-OpenStack model across 12+ multi-site data centers (40–50 servers/site), providing troubleshooting support for OpenStack services (Nova, Neutron, Cinder, Glance) and onboarding VNFs to enable 4G/5G expansion and support 72M+ NSA 5G subscribers.",
        "Engineered infrastructure and application lifecycle workflows for distributed OpenStack Telco clouds, enabling scale-in/scale-out of compute, storage, and controller nodes, onboarding Nokia and third-party applications, providing on-call production support, and driving migration from VM-based services to Dockerized deployments to improve scalability and reliability",
        "Contributed to the CBIS Manager GUI, a React-based dashboard integrated with RESTful APIs for OpenStack services, enabling efficient cluster lifecycle operations (scale-in/scale-out, onboarding, monitoring, security), streamlining infrastructure workflows to achieve up to 20% per-site capacity expansion and reduce high-severity issues via Ansible-based hardening.",
        "Designed and prototyped NetLingo, an machine learning and LLM-powered Network Intrusion Detection System, as part of an internal Nokia innovation hackathon, achieving 99.12% detection accuracy on KDD Cup 1999 and Kyoto 2006+ datasets using Random Forest, GridSearchCV, and RFE.",
        "Engineered a RAG-based security analytics pipeline, processing 9 TB+ PCAP data into a 2.3B-token corpus, and built a FAISS-based retrieval engine over 218K+ MITRE ATT&CK and CVE records using MiniLM-L6 embeddings, integrating the Gemini 1.0 nano API for zero-day threat analysis and explainability."
      ]
    },
    {
      role: "Embedded Systems Intern – R&D",
      company: "John Deere",
      companylogo: require("./assets/images/john_deere_logo_mod.png"),
      date: "May 2020 – July 2020",
      desc: "Worked at the intersection of embedded vision and robotics to build image acquisition pipelines for autonomous agricultural machinery.",
      descBullets: [
        "Integrated IMX390 HDR camera with NVIDIA Jetson Xavier to enable real-time image streaming and pre-processing",
        "Built a ROS-compatible image capture pipeline for agricultural autonomy prototypes",
        "Enabled real-time data handling and low-latency visualization in rugged environments for field testing"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Major Projects",
  subtitle: "Real-world web apps and research challenges I have contributed to",
  projects: [
    {
      image: require("./assets/images/YelpCamp.png"),
      projectName: "YelpCamp",
      projectDesc:
        "Full-stack campground review platform with user authentication, image uploads, and map integration. Built with Node.js, Express.js, and MongoDB Atlas (CRUD operations & REST APIs). Server-side rendering via EJS, styled with Bootstrap, and integrated Cloudinary for image storage and MapTiler for interactive maps. Authentication and authorization handled with Passport.js, deployed on Heroku.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://yelpofcamp-7a9b83777101.herokuapp.com"
        },
        //  you can add extra buttons here.
        {
          name: "GitHub",
          url: "https://github.com/hbhangale3/YelpCamp"
        }
      ]
    },
    {
      image: require("./assets/images/netlingo_default.png"),
      projectName:
        "NetLingo: LLM-Powered Network Intrusion Detection (SVCSI CyberWarrior 2025 Semi-Finalist)",
      projectDesc:
        "Protocol-aware intrusion detection system treating network traffic as natural language. Developed as part of the SVCSI 2025 Applied LLM Challenge (semi-finalist). Implemented hybrid ML + LLM pipeline using datasets (KDD99, Kyoto 2006+, CIC-IDS2018, UNSW-NB15) to detect and explain zero-day attacks. Fine-tuned Falcon models via QLoRA, built RAG-based explanations with Gemini, and used FAISS-powered MITRE/CVE index for real-time threat lookup.",
      footerLink: [
        {
          name: "GitHub",
          url: "https://github.com/hbhangale3/SVCC2025-Applied-LLM-Challenge"
        }
      ]
    },
    {
      image: require("./assets/images/Nomad Haven.png"),
      projectName: "NomadHaven",
      projectDesc:
        "Airbnb-like rental platform with property CRUD, authentication, image management, category-based search, and secure payment processing. Built on Next.js 14 (App Router, server components, server actions) and TypeScript for type-safe development. Backend uses Prisma ORM with Supabase Postgres; Supabase Storage handles secure image uploads. Integrated Stripe for seamless, secure booking payments. UI built with TailwindCSS, shadcn/ui, and next-themes for dark mode; Clerk powers authentication/authorization; deployed on Vercel.",
      footerLink: [
        {name: "Visit Website", url: "https://nomad-haven.vercel.app/"},
        {name: "GitHub", url: "https://github.com/hbhangale3/NomadHaven/"}
      ]
    },
    {
      image: require("./assets/images/astra_rag_default.png"),
      projectName:
        "AstraRAG: AI-Powered Study Buddy & Document Intelligence Platform",
      projectDesc:
        "Full-stack agentic RAG study assistant that lets users upload documents, chat with notes, generate source-grounded quizzes, and track learning progress through a Streamlit frontend and FastAPI backend. Built with ChromaDB, LlamaIndex, CrewAI agent orchestration, Groq LLMs, per-user document isolation, and authenticated user sessions. Extended with Prometheus and Grafana observability, Dockerized multi-service deployment, and a Jenkins CI + ArgoCD GitOps pipeline for cloud deployment on GKE.",
      footerLink: [
        {
          name: "GitHub",
          url: "https://github.com/hbhangale3/Astra-RAG-Chatbot"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements and Certifications 🏆"),
  subtitle:
    "Achievements, Certifications, Award Letters, and Research Milestones I’m proud of!",
  achievementsCards: [
    {
      title: "Microsoft Certified: Azure Fundamentals (AZ-900)",
      subtitle:
        "Earned Microsoft’s Azure Fundamentals certification validating cloud concepts, core Azure services, pricing, and governance.",
      image: require("./assets/images/Az900.png"),
      imageAlt: "Microsoft Azure Certification Logo",
      footerLink: [
        {
          name: "Certificate of Completion",
          url: "https://drive.google.com/file/d/1Zy0fYkvGM3cgR3oNmUnIYoWgfwnJVM5q/view?usp=sharing"
        }
      ]
    },
    {
      title: "Red Hat OpenStack Administration I (CL110)",
      subtitle:
        "Completed Red Hat's foundational OpenStack Administration course (CL110) focused on core operations for domain operators.",
      image: require("./assets/images/redhat_logo.png"),
      imageAlt: "Red Hat Logo",
      footerLink: [
        {
          name: "Certificate of Completion",
          url: "https://drive.google.com/file/d/1cUaG6AP31L3qVBq-UVXGBXu-Rb9lFgn_/view?usp=sharing"
        }
      ]
    },
    {
      title: "Internship Certificate – John Deere",
      subtitle:
        "Completed 2.5-month R&D internship on NVIDIA Jetson Xavier at John Deere India, working on GMSL driver modules and embedded camera pipelines.",
      image: require("./assets/images/john-deere-logo.png"),
      imageAlt: "John Deere Logo",
      footerLink: [
        {
          name: "Certificate of Completion",
          url: "https://drive.google.com/file/d/1AN3Keo5e9YQ9h7OqTARgrefEJxkTdnCG/view?usp=sharing"
        }
      ]
    },
    {
      title: "IEEE CAPS 2021 – Paper Presentation",
      subtitle:
        'Presented the research paper titled "Multi-feature Similarity-based Deep Learning Framework for Semantic Segmentation" on liver tumor segmentation using deep learning techniques (U-Net, skip connections, and feature similarity module) at IEEE CAPS 2021.',
      image: require("./assets/images/ieee.png"),
      imageAlt: "IEEE Conference Logo",
      footerLink: [
        {
          name: "Presentation Certificate",
          url: "https://drive.google.com/file/d/1tBiXPBeqIjWpUQ-5eGTiV-CzX0eVHNI-/view?usp=sharing"
        },
        {
          name: "View on IEEE Xplore",
          url: "https://ieeexplore.ieee.org/document/9730728"
        }
      ]
    }
  ],
  display: true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "false", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Whether it's code, cloud, or coffee – I’m always open to a good tech conversation.",
  number: "+1-6693409846",
  email_address: "hbhangale3@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "bhangale_3", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
